import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "@app/core/services/alert/alerts.service";

@Component({
  selector: 'app-alert-dialog',
  styles: ['.buttons-wrap { text-wrap: auto; }'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div>
      <div class="modal-header">
        <h4 class="modal-title">{{title}}{{alertType}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <p>{{message}}</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-secondary" (click)="modalRef.close('Close click')">Close</button>
      </div>
    </div>
  `
})
export class AlertDialogueComponent {
  title: string = "";
  message: string = "";
  alertType: AlertType = "success";

  constructor(public modalRef: NgbActiveModal) {
  }
}
